import React, { Fragment } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { arrayOf } from 'prop-types'
import { TEXT_MEDIUM, MAX_CONTENT_WIDTH } from '../../../constants'

import { SECONDARY_BUTTON } from '../../../constants/buttonThemes'
import { cardButtonShape } from '../../../types'
import Text from '../../shared/Text'

import Button from '../Button'
import Tooltip from '../Tooltip2'

const Wrapper = styled.div`
  display: flex;
  margin: auto 0 0;
  max-width: ${MAX_CONTENT_WIDTH};
`

const CheckboxItem = styled.label`
  display: flex;
  align-items: stretch;
`

const StyledButton = styled(Button)`
  margin-right: 15px;
`
const Spacer = styled.div`
  display: flex;
  flex-grow: 1;
`

const CheckboxLabel = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
`

const FeedAuditorTopButtons = ({
  buttons,
  checkboxText,
  isAdmin,
  showNullOrgIds,
  setShowNullOrgIds,
}) => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      {buttons &&
        buttons.map(
          ({ name, isHidden, tooltip, ...otherProps }) =>
            !isHidden && (
              <Tooltip title={tooltip} key={name}>
                <StyledButton
                  dataId={`${name}`}
                  key={name}
                  theme={SECONDARY_BUTTON}
                  {...otherProps}
                >
                  {t(name)}
                </StyledButton>
              </Tooltip>
            )
        )}
      {isAdmin && (
        <Fragment>
          <Spacer />
          <CheckboxItem>
            <input
              type="checkbox"
              checked={showNullOrgIds}
              theme={SECONDARY_BUTTON}
              style={{ marginRight: 10 }}
              onChange={setShowNullOrgIds}
            />
            <CheckboxLabel>
              <Text size={TEXT_MEDIUM}>{checkboxText}</Text>
            </CheckboxLabel>
          </CheckboxItem>
        </Fragment>
      )}
    </Wrapper>
  )
}

FeedAuditorTopButtons.propTypes = {
  buttons: arrayOf(cardButtonShape),
}

export default FeedAuditorTopButtons
